<template>
    <div>
        <modal ref="modal" @close="goBack()">
            <div class="bg-purple-900 text-white w-full h-full overflow-y-auto relative">
                <float-button class="bg-red-400 m-10" @click="destroy()">
                    <icon icon="times"></icon>
                </float-button>

                <div class="flex items-center justify-center w-full h-full" v-if="loading">
                    <div class="loader"></div>
                </div>

                <div v-if="!loading && schedule" class="p-10">
                    <h1 class="font-light">
                        {{ schedule.week_day_full }},
                        <br class="md:hidden"> {{ schedule.day_time }}
                    </h1>

                    <div class="p-2 border-l-2 mt-5">
                        <h2 class="uppercase font-bold mb-2">{{ $t('actions_to_be_executed') }}</h2>

                        <p v-for="(a, k) in schedule.actions" :key="k" class="pl-2 mb-2">
                            {{ a.name }}
                        </p>
                    </div>

                    <div class="p-2 border-l-2 mt-5">
                        <h2 class="uppercase font-bold mb-2">{{ $t('actions_logs') }}</h2>

                        <p v-if="!schedule.logs.length">
                            {{ $t('no_registered_logs') }}
                        </p>
                        <p v-for="(l, k) in schedule.logs" :key="k" class="pl-2 mb-4">
                            <span class="text-xs">{{ $filters.dt(l.created_at) }}</span> <br>
                            {{ l.description }}
                        </p>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    import {Zapin} from "@/services/Api";

    export default {
        props: {
            id: String
        },

        data() {
            return {
                loading: false,
                schedule: null
            }
        },

        mounted() {
            this.$refs.modal.open();

            this.loading = true;

            Zapin
                .schedules()
                .show(this.$route.params.id)
                .then((res) => {
                    this.schedule = res.data;
                })
                .finally(() => this.loading = false);
        },

        methods: {
            goBack() {
                history.go(-1);
            },

            destroy() {
                this.$router.push({
                    name: 'DeleteSchedule',
                    params: {
                        id: this.id
                    }
                })
            }
        }
    }
</script>